import { PartnersListComponent } from './Partnerss/partners-list/partners-list.component';
import { HeaderComponent } from './side-nav/header/header.component';
import { TicketSingleComponent } from './Ticket/ticket-single/ticket-single.component';
import { PremiumSingleComponent } from './premium/premium-single/premium-single.component';
import { UserSingleComponent } from './users/user-single/user-single.component';
import { ENovelPricingFormComponent } from './E-novels/e-novel-pricing-form/e-novel-pricing-form.component';
import { ENovelSeasonAddComponent } from './E-novels/e-novel-season-add/e-novel-season-add.component';
import { ENovelSeriesAddComponent } from './E-novels/e-novel-series-add/e-novel-series-add.component';
import { EComicEpisodeAddComponent } from './E-comics/e-comic-episode-add/e-comic-episode-add.component';
import { EComicPricingFormComponent } from './E-comics/e-comic-pricing-form/e-comic-pricing-form.component';
import { EComicSeasonAddComponent } from './E-comics/e-comic-season-add/e-comic-season-add.component';
import { EComicSeriesAddComponent } from './E-comics/e-comic-series-add/e-comic-series-add.component';
import { PartnersComponent } from './Partnerss/partners/partners.component';
import { TermsConditionsComponent } from './extras/terms-conditions/terms-conditions.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { TicketsComponent } from './Ticket/tickets/tickets.component';
import { AdminComponent } from './admins/admin/admin.component';
import { PremiumListComponent } from './premium/premium-list/premium-list.component';
import { ENovelChapterComponent } from './E-novels/e-novel-chapter/e-novel-chapter.component';
import { ENovelSeriesComponent } from './E-novels/e-novel-series/e-novel-series.component';
import { EComicEpisodeComponent } from './E-comics/e-comic-episode/e-comic-episode.component';
import { EComicSeasonsComponent } from './E-comics/e-comic-seasons/e-comic-seasons.component';
import { EComicSeriesComponent } from './E-comics/e-comic-series/e-comic-series.component';
import { HomeMobileappComponent } from './home-mobileapp/home-mobileapp.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Routes } from '@angular/router';
import { ENovelSeasonsComponent } from './E-novels/e-novel-seasons/e-novel-seasons.component';
import { UsersListComponent } from './users/users-list/users-list.component';
import { AboutUsComponent } from './extras/about-us/about-us.component';
import { PrivacyPolicyComponent } from './extras/privacy-policy/privacy-policy.component';
import { RefundPolicyComponent } from './extras/refund-policy/refund-policy.component';
import { LoginComponent } from './login/login.component';
import{ ContactComponent }from './extras/contact/contact.component';
import { ENovelChapterAddComponent } from './E-novels/e-novel-chapter-add/e-novel-chapter-add.component';
import { UserAddComponent } from './admins/user-add/user-add.component';
import { ChangePasswordComponent } from './extras/change-password/change-password.component';
// services
import { AuthService } from './service/auth.service';
import { LoginGuard } from './service/login.guard';
import { WisSeasonsComponent } from './wis/wis-seasons/wis-seasons.component';
import { WisEpisodesComponent } from './wis/wis-episodes/wis-episodes.component';
import { AddWisSeasonComponent } from './wis/add-wis-season/add-wis-season.component';
import { WisEpisodeAddComponent } from './wis/wis-episode-add/wis-episode-add.component';
import { WisPricingComponent } from './wis/wis-pricing/wis-pricing.component';
import { OurWrittersComponent } from './our-writters/our-writters.component';
import { AddWritterComponent } from './our-writters/add-writter/add-writter.component';
import { SendEmailComponent } from './send-email/send-email.component';
import { EmailHistoryComponent } from './send-email/email-history/email-history.component';
import { AddUserComponent } from './users/add-user/add-user.component';
import { OffersComponent } from './offers/offers.component';
import { AddOfferComponent } from './offers/add-offer/add-offer.component';
import { UpcomingReleasesComponent } from './upcoming-releases/upcoming-releases.component';
import { AddUpcomingReleaseComponent } from './upcoming-releases/add-upcoming-release/add-upcoming-release.component';

export const routes: Routes = [
  // {
  //     path: '',
  //     redirectTo: 'admin',
  //     pathMatch: 'full'
  //   },
  {
    path: '',
    component: HeaderComponent,
    children: [
      {
        path: '',
        component: DashboardComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'mobileapp',
        component: HomeMobileappComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'comic-series',
        component: EComicSeriesComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'comic-seasons',
        component: EComicSeasonsComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'comic-episode',
        component: EComicEpisodeComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'novel-series',
        component: ENovelSeriesComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'novel-seasons',
        component: ENovelSeasonsComponent,
        canActivate: [LoginGuard],
      },
    {
      path: 'novel-chapter',
      component: ENovelChapterComponent,
      canActivate: [LoginGuard],
    },
    {
      path : 'users',
      component: UsersListComponent,
      canActivate: [LoginGuard],
    },
    {
        path: 'premium',
        component: PremiumListComponent,
        canActivate: [LoginGuard],
      },
    {
      path: 'admin',
      component: AdminComponent,
      canActivate: [LoginGuard],
    },
    {
        path : 'tickets',
        component: TicketsComponent,
        canActivate: [LoginGuard],
    },
    {
      path: 'feedback',
        component: FeedbackComponent,
        canActivate: [LoginGuard],
      },
    {
      path : 'aboutus',
      component: AboutUsComponent,
      canActivate: [LoginGuard],
    },
    {
        path: 'terms-conditons',
        component: TermsConditionsComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'refund-policy',
        component: RefundPolicyComponent
      },
      {
        path: 'contact',
        component: ContactComponent
      },
    {
      path: 'partners',
      component: PartnersComponent,
      canActivate: [LoginGuard],
    },
    {
      path : 'change-password',
      component: ChangePasswordComponent,
    },
    {
      path: 'comic-series-add',
      component: EComicSeriesAddComponent,
      canActivate: [LoginGuard],
      children: [{
        path: ':id',
        component: EComicSeriesAddComponent
      }],
    },
    {
        path: 'comic-seasons-add',
        component: EComicSeasonAddComponent,
        canActivate: [LoginGuard],
        children: [{
          path: ':id',
          component: EComicSeasonAddComponent
        }],
      },
      {
        path: 'comic-pricing',
        component: EComicPricingFormComponent,
        canActivate: [LoginGuard],
        children: [{
          path: ':id',
          component: EComicPricingFormComponent
        }],
    },
    {
      path: 'comic-episode-add',
      component: EComicEpisodeAddComponent,
      canActivate: [LoginGuard],
      children: [{
        path: ':id',
        component: EComicEpisodeAddComponent
      }],
    },
    {
      path: 'novel-series-add',
      component: ENovelSeriesAddComponent,
      canActivate: [LoginGuard],
      children: [{
        path: ':id',
        component: ENovelSeriesAddComponent
      }],
    },
    {
      path: 'novel-seasons-add',
        component: ENovelSeasonAddComponent,
        canActivate: [LoginGuard],
        children: [{
          path: ':id',
          component: ENovelSeasonAddComponent
        }],
      },
    {
      path: 'novel-pricing',
      component: ENovelPricingFormComponent,
      canActivate: [LoginGuard],
      children: [{
        path: ':id',
        component: EComicPricingFormComponent
      }],
    },
    {
        path: 'novel-chapter-add',
        component: ENovelChapterAddComponent,
        canActivate: [LoginGuard],
        children: [{
          path: ':id',
          component: ENovelChapterAddComponent
        }],
      },
      {
        path: 'user-single/:id',
        canActivate: [LoginGuard],
        component: UserSingleComponent,
      },
      {
        path: 'premium-single/:id',
        canActivate: [LoginGuard],
        component: PremiumSingleComponent,
    },
    {
      path: 'admin-add',
      canActivate: [LoginGuard],
      component: UserAddComponent,
    },
    {
      path: 'admin-edit/:id',
      canActivate: [LoginGuard],
      component: UserAddComponent,
    },
    {
      path: 'ticket-single/:id',
      canActivate: [LoginGuard],
      component: TicketSingleComponent,
    },
    {
      path: 'partners-list',
      canActivate: [LoginGuard],
      component: PartnersListComponent,
    },
    {
      path: 'wis-season',
      canActivate: [LoginGuard],
      component: WisSeasonsComponent,
    },
    {
      path: 'wis-episodes',
      canActivate: [LoginGuard],
      component: WisEpisodesComponent,
    },
    {
      path: 'add-wis-season',
      canActivate: [LoginGuard],
      component: AddWisSeasonComponent,
    },
    {
      path: 'add-wis-season/:id',
      canActivate: [LoginGuard],
      component: AddWisSeasonComponent,
    },
    {
      path:'wis-episode-add',
      component:WisEpisodeAddComponent,
      canActivate: [LoginGuard],
    },
    {
      path:'wis-episode-add/:id',
      component:WisEpisodeAddComponent,
      canActivate: [LoginGuard],
    },
    {
      path:'wis-pricing/:id',
      component:WisPricingComponent,
      canActivate: [LoginGuard],
    },
    {
      path:'our-writers',
      component:OurWrittersComponent,
      canActivate: [LoginGuard],
    },
    {
      path:'add-writer',
      component:AddWritterComponent,
      canActivate: [LoginGuard],
    },
    {
      path:'add-writer/:id',
      component:AddWritterComponent,
      canActivate: [LoginGuard],
    },
    {
      path:'send-email',
      component:SendEmailComponent,
      canActivate: [LoginGuard],
    },
    {
      path:'email-history',
      component:EmailHistoryComponent,
      canActivate: [LoginGuard],
    },
    {
      path:"add-user",
      component:AddUserComponent,
      canActivate:[LoginGuard]
    },
    {
      path:"offers",
      component:OffersComponent,
      canActivate:[LoginGuard]
    },
    {
      path:"add-offer/:id",
      component:AddOfferComponent,
      canActivate:[LoginGuard]
    },
    {
      path:"add-offer",
      component:AddOfferComponent,
      canActivate:[LoginGuard]
    },
    {
      path:"upcoming-releases",
      component:UpcomingReleasesComponent,
      canActivate:[LoginGuard]
    },
    {
      path:"add-upcoming-release",
      component:AddUpcomingReleaseComponent,
      canActivate:[LoginGuard]
    },
    {
      path:"add-upcoming-release/:id",
      component:AddUpcomingReleaseComponent,
      canActivate:[LoginGuard]
    },
  ]},
  {
      path: 'login',
      component: LoginComponent,
  },
  {path: '**', redirectTo: ''}
];



// WEBPACK FOOTER //
// ./src/app/webbel-admin-routes.ts